import { Subject } from './../subject.interface';
import { AssessmentCategory } from "./assessment-category";
import { Class } from '../learning-path/class.interface';
import { Section } from '../learning-path/section.interface';
import { Teacher } from 'src/app/templates/models/teacher.interface';

export class AuditAnalysis {
    assessmentCategory: AssessmentCategory;
    assessment: any;
    subject: Subject;
    class:Class;
    section:Section;
    teachers:Teacher[];
    enteredMarkPercentage:number;
    firstAuditPercentage:number;
    secondAuditPercentage:number;
  }
  